export default __webpack_public_path__ + "static/media/warning.869c43cc.svg";